import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { AlertasService } from '../../../core/services/alertas.service';
import { HUB_TEST_CONFIG } from '../../../modules/pruebas-hub/config/hub-test.config';
import { AppIconComponent } from '../../components/app-icon/app-icon.component';

interface NavItem {
  label: string;
  icon: string;
  route: string;
  /** muestra el conteo de alertas abiertas como badge. */
  badge?: boolean;
}

/**
 * Navegación principal del panel como barra horizontal de pestañas (reemplaza la barra lateral).
 * Las 4 vistas del flujo de cesión (Análisis §7) + la administración (parametrización), en un
 * solo control segmentado que se desplaza en pantallas angostas.
 */
const MENU: NavItem[] = [
  { label: 'Vigilancia', icon: 'eye', route: '/dashboard', badge: true },
  { label: 'Seguimiento', icon: 'track', route: '/seguimiento' },
  { label: 'Elegibles', icon: 'doc', route: '/elegibles' },
  { label: 'Conciliación', icon: 'reconcile', route: '/conciliacion' },
  { label: 'Parametrización', icon: 'settings', route: '/parametrizacion' },
  ...(HUB_TEST_CONFIG.habilitado
    ? [{ label: 'Pruebas del hub', icon: 'code', route: '/pruebas-hub' }]
    : []),
];

@Component({
  selector: 'app-topnav',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, AppIconComponent],
  templateUrl: './app-topnav.component.html',
})
export class AppTopnavComponent {
  private readonly alertas = inject(AlertasService);

  protected readonly items = MENU;
  private readonly abiertas = toSignal(this.alertas.getAbiertas(), { initialValue: [] });
  protected readonly alertCount = computed(() => this.abiertas().length);
}
